<template>
  <el-dialog custom-class="medium-dialog" title="修改地址" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true"
  >
    <el-row>
      <el-col :span="24">
        <el-table
          :data="addressData"
          :height="tableHeight(100)"
          ref="moviesTable"
          size="mini"
          stripe
          border
          @selection-change="handleSelectionChange"
          style="width: 100%;">
          <el-table-column
            type="selection"
            width="80">
          </el-table-column>

          <el-table-column
            prop="uname"
            label="联系人"
            align="left"
            width="150"
            header-align="center">
          </el-table-column>

          <el-table-column
            prop="mobile"
            label="联系电话"
            align="center"
            header-align="center"
            width="180">
          </el-table-column>

          <el-table-column
            prop="deliveryaddress"
            label="收货地址"
            align="center"
            header-align="center">
          </el-table-column>

        </el-table>
        </div>
      </el-col>
    </el-row>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :disabled="isDisable">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>

  import {saveCstagreementData} from '@/api/set/csagreement';
  import {getAddressListData} from '@/api/set/parameter';

  export default {
    name: "aaa",
    data() {
      return {
        isDisable: false,
        dialogFormVisible: false,
        form: {
          unitguid: '',//表单数据
          deliveryaddress: '',
          linkman: '',
          linkmantel: ''
        },
        tabledata: [],
        addressData: [],
        formLabelWidth: '120px',
        rules: {////////定义正则验证字段。
          deliveryaddress: [
            {required: true, message: '请选择联系地址', trigger: 'blur'},
          ],
          linkman: [
            {required: true, message: '请输入联系人', trigger: 'blur'},
          ],
          linkmantel: [
            {required: true, message: '请输入联系电话', trigger: 'blur'},
          ]
        },
      }
    },
    methods: {
      show(item) {
        this.initForm();
        this.dialogFormVisible = true;
        this.form.unitguid=item.unitguid
        getAddressListData({customerserial: item.customerserial}).then(response => {
          this.addressData = response.data.obj
          for (let i in this.addressData) {
            this.addressData[i]["deliveryaddress"] = this.addressData[i].province + this.addressData[i].city + this.addressData[i].county + this.addressData[i].address
          }
        })
      },
      handleSelectionChange(val) {
        if (val && val.length > 0) {
          for (var i = 0; i < val.length - 1; i++) {
            this.$refs.moviesTable.toggleRowSelection(val[i], false)
          }
        }
        this.tabledata = val;
      },
      saveData() {
        if(this.tabledata.length>0){
          this.form.deliveryaddress = this.tabledata[0].deliveryaddress
          this.form.linkman = this.tabledata[0].uname
          this.form.linkmantel = this.tabledata[0].mobile
          saveCstagreementData(this.form).then(response => {
            if (response.data.code == 0) {
              this.$message({
                message: '保存成功',
                type: 'success'
              })
              this.$emit('afertupdate', this.form.deliveryaddress, this.form.linkman, this.form.linkmantel);
              this.dialogFormVisible = false;
            } else {
              this.$message({
                message: response.data.msg,
                type: 'error'
              })
            }
          })
        }else {
          this.$message({
            message:'请选择地址',
            type: 'error'
          })
        }
      },
      initForm() {
        if (this.$refs.form1 != undefined) {
          this.$refs.form1.resetFields();
        }
      }
    },
    mounted() {
    },
    components: {},
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/UpdateAddress.vue